"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticationTokens = void 0;
exports.AuthenticationTokens = {
    Identity: Symbol.for('shared.Identity'),
    AccessToken: Symbol.for('shared.AccessToken'),
};
//# sourceMappingURL=authentication.tokens.js.map